import { defineRecipe } from '@plurall/elo-v3';

// ─── Topbar (outer header) ────────────────────────────────────────────────────

export const topbarRecipe = defineRecipe({
  className: 'topbar',
  base: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    gridRow: 1,
    gridColumn: '1 / -1',
    display: 'flex',
    alignItems: 'center',
    minHeight: 'var(--topbar-height)',
    width: '100%',
    background: 'background.brand.alt',

    // O chrome do app não faz parte de relatórios impressos, como já ocorre
    // com a sidebar (ver LocalNavigation.factory.ts).
    _print: { display: 'none' },
  },
});

// ─── Nav root ─────────────────────────────────────────────────────────────────

export const navRootRecipe = defineRecipe({
  className: 'global-navigation',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
    flexWrap: 'wrap',
  },
  variants: {
    isOpen: {
      true: { flexDirection: 'column', alignItems: 'stretch' },
      false: {},
    },
  },
  defaultVariants: { isOpen: false },
});

// ─── Nav start / end ─────────────────────────────────────────────────────────

export const navStartRecipe = defineRecipe({
  className: 'global-navigation__start',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
    height: 'size.56',
    paddingTop: 'space.8',
    paddingRight: 'space.16',
    paddingBottom: 'space.8',
    paddingLeft: 'space.8',
  },
  variants: {
    isOpen: {
      true: { minHeight: 'size.40' },
      false: {},
    },
  },
  defaultVariants: { isOpen: false },
});

export const navEndRecipe = defineRecipe({
  className: 'global-navigation__end',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
    height: 'size.56',
    paddingTop: 'space.8',
    paddingRight: 'space.16',
    paddingBottom: 'space.8',
    paddingLeft: 'space.8',
  },
});

// ─── Nav center (InnerPageTopBar) ─────────────────────────────────────────────

export const navCenterRecipe = defineRecipe({
  className: 'global-navigation__center',
  base: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 0,
  },
});

// ─── Nav title (InnerPageTopBar) ─────────────────────────────────────────────

export const navTitleRecipe = defineRecipe({
  className: 'global-navigation__title',
  base: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    fontSize: 'font-size-medium',
    fontWeight: 'font-weight-medium',
  },
});

// ─── Nav action button ────────────────────────────────────────────────────────

export const navActionButtonRecipe = defineRecipe({
  className: 'global-navigation__action-btn',
  base: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 'size.40',
    height: 'size.40',
    minWidth: 'size.40',
    minHeight: 'size.40',
    maxWidth: 'size.40',
    maxHeight: 'size.40',
    padding: 0,
    border: 'none',
    background: 'transparent',
    borderRadius: '50%',
    color: 'foreground.inverse',
    cursor: 'pointer',

    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '2px',
    },

    '& svg': {
      width: 'size.24',
      height: 'size.24',
      minWidth: 'size.24',
      minHeight: 'size.24',
      flexShrink: 0,
      display: 'block',
    },
  },
});
